var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M257.8,48.61a105,105,0,0,1-30.17,8.26,52.71,52.71,0,0,0,23.1-29,105.33,105.33,0,0,1-33.36,12.74,52.57,52.57,0,0,0-89.5,47.91A149.12,149.12,0,0,1,19.61,33.59a52.58,52.58,0,0,0,16.26,70.12,52.08,52.08,0,0,1-23.79-6.58c0,.23,0,.45,0,.67a52.55,52.55,0,0,0,42.14,51.49,52.18,52.18,0,0,1-13.84,1.85,52.7,52.7,0,0,1-9.88-.94,52.59,52.59,0,0,0,49.06,36.48,105.34,105.34,0,0,1-65.23,22.48,105.63,105.63,0,0,1-12.52-.74A148.52,148.52,0,0,0,82.3,232c96.61,0,149.44-80,149.44-149.44,0-2.27-.05-4.54-.16-6.79A106.54,106.54,0,0,0,257.8,48.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.784368ca.svg";
export { ForwardRef as ReactComponent };